import { Injectable, signal } from '@angular/core';

/**
 * Tracks unsaved form dirty state across the portfolio setup page.
 * Used by UnsavedChangesGuard to prompt before navigation.
 */
@Injectable({ providedIn: 'root' })
export class FormDirtyService {
  readonly isDirty = signal(false);

  markDirty(): void {
    this.isDirty.set(true);
  }

  markClean(): void {
    this.isDirty.set(false);
  }
}
